import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "Are there any fees or commissions?",
    a: "None. We charge zero fees and zero commissions, and we cover all standard closing costs. The offer we make is the amount you walk away with.",
  },
  {
    q: "Will you list my house or actually buy it?",
    a: "We buy your house directly. We are not agents listing your property — we are the buyers, which is why we can close so quickly and on your schedule.",
  },
  {
    q: "How do you determine your offer?",
    a: "We look at your home's location, its current condition, needed repairs, and recent comparable sales in your area. Then we make a fair, no-obligation cash offer.",
  },
  {
    q: "Do I need to make repairs or clean up first?",
    a: "No. We buy houses completely as-is. Leave what you don't want, skip the repairs, and don't worry about cleaning — we handle all of it.",
  },
  {
    q: "Is there any obligation if I request an offer?",
    a: "None at all. Requesting an offer is 100% free with no obligation. If it's not the right fit for you, there's no pressure and no cost.",
  },
];

export const FAQ = () => (
  <section
    id="faq"
    data-testid="faq-section"
    className="bg-stone-100 py-20 md:py-32 px-6 md:px-12 lg:px-16"
  >
    <div className="max-w-3xl mx-auto">
      <div className="text-center">
        <span className="uppercase text-xs md:text-sm tracking-[0.2em] font-semibold text-emerald-700">
          Questions & Answers
        </span>
        <h2 className="font-heading mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900">
          Common Questions
        </h2>
      </div>

      <Accordion type="single" collapsible className="mt-12 space-y-4">
        {faqs.map((f, i) => (
          <AccordionItem
            key={i}
            value={`item-${i}`}
            data-testid={`faq-item-${i + 1}`}
            className="bg-white rounded-2xl border border-stone-200 px-6"
          >
            <AccordionTrigger className="text-left font-heading font-semibold text-slate-900 text-lg hover:no-underline py-5">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-slate-600 text-base leading-relaxed pb-5">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);
